// extracted by mini-css-extract-plugin
export var circle = "_aj-1";
export var exitConfirmationModal = "_aj-5";
export var iframe = "_aj-0";
export var offline = "_aj-3";
export var online = "_aj-2";
export var workstationSelectError = "_aj-4";